import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../styles/utils/Header.scss";
import { useSelectedStoryID } from "../../SelectedBookContext";
import i18n from "../../i18n";
import getLocalizedLogo from "../../utils/getLocalizedLogo";

const Header = () => {
  const [, setLanguageTick] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const USER_TYPE = localStorage.getItem("userType");
  const ORGANIZATION = localStorage.getItem("organization");

  const isHome = location.pathname === "/home";
  const isMyStorybook = location.pathname === "/myStorybook";
  const isStoryland = location.pathname === "/storyland";
  const isSelecting = location.pathname === "/selecting";

  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);

  const toggleHamburgerMenu = () => {
    setShowHamburgerMenu(!showHamburgerMenu);
  };

  const USER_NAME = localStorage.getItem("userName") ?? "";
  const { STORYID } = useSelectedStoryID();

  const isStoriesPage = location.pathname === `/making/${STORYID}`;
  const isReadingPage = location.pathname === `/reading`;
  const isBranchPage = location.pathname === `/making/custom`;
  const isAudioReadingPage = location.pathname === "/audio-reading";
  const isSharedPage =
    location.pathname === "/share" || location.pathname === "/audio-share";
  const headerClassName = `${
    isStoriesPage || isReadingPage || isAudioReadingPage || isBranchPage
      ? "hovered"
      : isSharedPage
        ? "share"
        : ""
  }`;
  const [isMouseOver, setIsMouseOver] = useState(false);
  const handleMouseEnter = () => setIsMouseOver(true);
  const handleMouseLeave = () => setIsMouseOver(false);

  React.useEffect(() => {
    const rerenderByLanguage = () => {
      setLanguageTick((prev) => prev + 1);
    };

    i18n.on("languageChanged", rerenderByLanguage);

    return () => {
      i18n.off("languageChanged", rerenderByLanguage);
    };
  }, []);

  const t = (key) => i18n.t(key, { ns: "components/utils/header" });

  return (
    <>
      <header
        id="header"
        className={headerClassName}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <div className="inner">
          <div className="header-left">
            {ORGANIZATION === "gyeongnam" ? (
              <h1
                className="logo"
                onClick={() => {
                  navigate("/storyland");
                }}
              >
                <img
                  src={"/images/logo/deep-sea-title.webp"}
                  alt="gyeongnam-main-logo"
                ></img>
              </h1>
            ) : (
              <h1 className="logo" onClick={() => navigate(`/home`)}>
                <img
                  src={"/images/logo/default-logo.svg"}
                  alt="main-logo"
                ></img>
              </h1>
            )}

            {ORGANIZATION !== "gyeongnam" ? (
              <nav className="nav">
                <ul>
                  <li
                    className={isHome ? "active" : ""}
                    onClick={() => navigate(`/home`)}
                  >
                    {t("home")}
                  </li>
                  <li
                    className={isMyStorybook ? "active" : ""}
                    onClick={() => navigate(`/myStorybook`)}
                  >
                    {t("myStorybook")}
                  </li>
                  <li
                    className={isStoryland ? "active" : ""}
                    onClick={() => navigate(`/storyland`)}
                  >
                    {t("storyland")}
                  </li>
                  <li
                    className={isSelecting ? "active" : ""}
                    onClick={() => navigate(`/selecting`)}
                  >
                    {t("makingStory")}
                  </li>
                </ul>
              </nav>
            ) : null}
          </div>
          <div className="header-right">
            {ORGANIZATION !== "gyeongnam" ? (
              <span
                className="back-magickid-btn"
                onClick={() => {
                  if (!isMouseOver) return;
                  window.close();
                }}
              >
                <figure>
                  <img
                    src={getLocalizedLogo(
                      "/images/utils/button/back-magickid-3.svg",
                    )}
                    alt=""
                  />
                </figure>
              </span>
            ) : (
              <span
                className="back-magickid-btn"
                onClick={() => {
                  if (!isMouseOver) return;
                  window.close();
                }}
              >
                <figure>
                  <img src={"/images/utils/button/backToSea.png"} alt="" />
                </figure>
              </span>
            )}

            <span className="user-id">
              {USER_NAME.length > 3 && (
                <>
                  {USER_NAME}
                  <span className="sir">
                    {t("honorific") ? ` ${t("honorific")}` : ""}
                  </span>
                </>
              )}
            </span>
          </div>
          {/* -------------모바일 메뉴------------- */}
          <div className="hamburger-mobile">
            <button onClick={toggleHamburgerMenu}>
              <figure>
                <img src={"/images/header/menu.svg"} alt="" />
              </figure>
              <span>{t("menu")}</span>
            </button>
          </div>
          {showHamburgerMenu && (
            <div className="ham-fixed">
              <div
                className="close-m"
                onClick={() => {
                  setShowHamburgerMenu(false);
                }}
              >
                <button>
                  <img src={"/images/utils/close.png"} alt="close-btn" />
                </button>
              </div>
              <p className="name-container">
                {USER_NAME}
                <span className="sir">
                  {t("honorific") ? ` ${t("honorific")}` : ""}
                </span>
              </p>
              <ul className="navi">
                <li
                  className="my-library"
                  onClick={() => {
                    if (!isMouseOver) return;
                    setShowHamburgerMenu(false);
                    navigate(`/myStorybook`);
                  }}
                >
                  {t("myStorybook")}
                </li>
                <li
                  className="storyland"
                  onClick={() => {
                    if (!isMouseOver) return;
                    setShowHamburgerMenu(false);
                    navigate(`/storyland`);
                  }}
                >
                  {t("storyland")}
                </li>
                <li
                  className="storyland"
                  onClick={() => {
                    if (!isMouseOver) return;
                    setShowHamburgerMenu(false);
                    navigate(`/selecting`);
                  }}
                >
                  {t("makingStory")}
                </li>
                <li
                  className="back-magic-kid"
                  onClick={() => {
                    if (!isMouseOver) return;
                    window.close();
                  }}
                >
                  {t("backToMagickid")}
                </li>
              </ul>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
